/**
 * Golden Hippo brand tokens — the single source of truth for both themes.
 * Values come from the Golden Hippo brand system (yellow `#edbf26` signature,
 * ink neutrals). Status hues are held deliberately distinct from the brand
 * yellow so a "warning" never reads as a brand accent on the health dashboard.
 */
export const GH = {
  // Brand / accent
  yellow500: '#edbf26', // signature: active nav, primary CTA, page-header rule
  yellow400: '#f3cf57', // hover / dark-mode link
  yellow600: '#c99e0f', // pressed / dark accent
  yellow100: '#fdf4d4',

  // Ink neutrals
  ink900: '#0f1115',
  ink700: '#2a2f3a',
  ink500: '#5b6373',
  ink300: '#c5cad3',
  ink100: '#eef0f4',
  ink50: '#f7f8fa',
  white: '#ffffff',
} as const;

/** Dark theme ground (the default). */
export const DARK = {
  bg: '#0f1115',
  rail: '#0b0d10',
  paper: '#191d24',
  card: '#1a1f28',
  border: 'rgba(255, 255, 255, 0.07)',
  textPrimary: '#f3f5f8',
  textSecondary: '#9aa2b1',
  textSubtle: '#7f8798',
  navColor: '#aeb6c2',
  navHover: 'rgba(237, 191, 38, 0.09)',
  submenu: '#11141a',
  headerGradient: 'linear-gradient(100deg, #14181f 0%, #1b212b 100%)',
  headerColors: ['#14181f', '#1b212b'],
} as const;

/** Light theme ground. Nav rail stays dark for a consistent wordmark. */
export const LIGHT = {
  bg: '#f7f8fa',
  paper: '#ffffff',
  card: '#ffffff',
  rail: '#12151b',
  border: '#e6e8ec',
  textPrimary: '#0f1115',
  textSecondary: '#5b6373',
  textSubtle: '#6a7283',
  navColor: '#aeb6c2',
  navHover: 'rgba(237, 191, 38, 0.10)',
  submenu: '#1b1f27',
  headerGradient: 'linear-gradient(100deg, #ffffff 0%, #f1f2f6 100%)',
  headerColors: ['#ffffff', '#f1f2f6'],
} as const;

/** Semantic status hues, tuned per ground for contrast. */
export const DARK_STATUS = { ok: '#4cc281', warning: '#f2a34b', error: '#f2555a' } as const;
export const LIGHT_STATUS = { ok: '#2e9e5b', warning: '#d9822b', error: '#d64550' } as const;

/** Font stacks. Poppins carries headings; Inter carries UI/body. Both self-hosted. */
export const FONT_DISPLAY =
  "'Poppins', 'Segoe UI', system-ui, -apple-system, BlinkMacSystemFont, sans-serif";
export const FONT_BODY =
  "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
